import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
} from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { DatePicker } from "@material-ui/pickers";
import { useAuth } from "../../context/GlobalContext";
import formatDate from "../../components/Control/formatDate";
import useConfirm from "../../components/Control/useConfirm";
import UpdateIcon from "@material-ui/icons/Update";
import ApprovalSelect from "./ApprovalSelect";
import ApprovalSupervisor from "./ApprovalSupervisor";

const statusObj = {
  pending: 1,
  accepted: 2,
  rejected: 3,
};

const useStyles = makeStyles({
  table: {
    width: "100%",
    marginTop: "1.5rem",
    backgroundColor: "white",
  },
});

const DailyProductionTable = () => {
  const classes = useStyles();
  const { state } = useAuth();
  const [dailyproductionData, setDailyProductionData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [render, setRender] = useState(false);
  const [DialogDelete, confirmDelete] = useConfirm(
    "SAVE",
    "Are you sure you want to Delete this report?",
  );

  useEffect(() => {
    axios
      .get(`/api/getDailyProduction/all/${selectedDate}/${state.user.userType}`)
      .then((res) => setDailyProductionData(res.data));
  }, [selectedDate, render]);

  const handleDelete = async (id) => {
    // const isConfirm = window.confirm(
    //   "Are you sure you want to delete this document"
    // );
    const isConfirm = await confirmDelete();
    if (isConfirm) {
      axios
        .delete(`/api/deleteDailyProduction/${id}`)
        .then((res) => {
          alert("success deleted");
          setRender((prev) => !prev);
        })
        .catch((err) => console.error(err));
    }
  };

  const handleChangeStatus = (e, index) => {
    const values = [...dailyproductionData];
    values[index].is_admin_request = null;
    values[index].is_admin_request_no = e.target.value;
    setDailyProductionData(values);
  };

  const updateStatus = async (id, index) => {
    let isConfirm = window.confirm("Are you sure you want to update status");
    if (!isConfirm) return;

    axios
      .patch(`/api/updateStatusDailyProductionId/${id}`, {
        is_admin_request_no: dailyproductionData[index].is_admin_request_no,
        report_approved_by: state.user?.name,
      })
      .then((res) => {
        if (res.data.status === "success") {
          alert("Status Change successfully");
        }
        setRender((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <section>
      <div style={{}}>
        <div
          className="divflex"
          style={{
            fontSize: "24px",
          }}
        >
          DAILY PRODUCTION REPORT
          <div
          // className="text"
          >
            {(state.user.userType === 3 || state.user.userType === 2) && (
              <Link
                to={`/createDailyProduction/table`}
                style={{ color: "white", textDecoration: "none" }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  style={{
                    // marginBottom: "2rem",

                    backgroundColor: "#054a29",
                  }}
                  startIcon={<AddCircleIcon />}
                >
                  New Report
                </Button>
              </Link>
            )}
          </div>
        </div>

        <div className="subheading-container">
          <p className="subheading-primary">
            ACTIVE <span className="subheading-secondary">REPORTS</span>
          </p>
        </div>
      </div>
      <div style={{ display: "flex", margin: "1rem" }}>
        <DatePicker
          views={["month", "year"]}
          label="Month & Year"
          className="date-field"
          inputVariant="filled"
          value={selectedDate || null}
          onChange={setSelectedDate}
        />
      </div>
      <Table className={classes.table} size="small">
        <TableHead>
          <TableRow style={{ padding: "6px" }}>
            {[
              "#",
              "Old Department",
              "Department",
              "Status",
              "Created At",
              "Action",
            ].map((item, index) => (
              <TableCell style={{ fontWeight: "bold" }} align="center">
                {item}
              </TableCell>
            ))}
            {state.user?.userType === 2 && (
              <TableCell style={{ fontWeight: "bold" }} align="center">
                Update
              </TableCell>
            )}
          </TableRow>
        </TableHead>
        {dailyproductionData && (
          <TableBody>
            {dailyproductionData.map((item, index) => (
              <React.Fragment key={item._id}>
                <TableRow>
                  <TableCell align="center">{index + 1}</TableCell>
                  <TableCell align="center">{item.department}</TableCell>
                  <TableCell align="center">
                    {item.department_id?.department_name}
                  </TableCell>
                  {/* approval */}
                  {state.user?.userType === 2 && (
                    <TableCell align="center">
                      <ApprovalSelect
                        {...{
                          handleChangeStatus,
                          item,
                          index,
                          statusObj,
                        }}
                      />
                    </TableCell>
                  )}

                  {state.user?.userType === 3 && (
                    <TableCell align="center">
                      <ApprovalSupervisor
                        {...{
                          item,
                        }}
                      />
                    </TableCell>
                  )}

                  <TableCell align="center">
                    {formatDate(item.dailyProduction_date)}
                  </TableCell>

                  {/* ---x--- */}
                  <TableCell align="center">
                    <Tooltip title="View Daily Production" arrow>
                      <Link to={`/viewDailyProductiontable/${item._id}`}>
                        <IconButton size="small">
                          <VisibilityIcon
                            style={{
                              fontSize: "1.4rem",
                              color: "#003566",
                            }}
                          />
                        </IconButton>
                      </Link>
                    </Tooltip>
                    {state.user.userType !== 3 && (
                      <>
                        <Tooltip title="Edit Daily Production" arrow>
                          <Link to={`/createDailyProduction/table/${item._id}`}>
                            <IconButton
                              size="small"
                              style={{ marginLeft: "0.5rem" }}
                            >
                              <EditIcon
                                style={{
                                  fontSize: "1.4rem",
                                  color: "#003566",
                                }}
                              />
                            </IconButton>
                          </Link>
                        </Tooltip>
                        <Tooltip title="Delete Daily Production" arrow>
                          <IconButton
                            size="small"
                            onClick={() => handleDelete(item._id)}
                            style={{ marginLeft: "0.5rem" }}
                          >
                            <DeleteIcon
                              style={{
                                fontSize: "1.4rem",
                                color: "#c80202",
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      </>
                    )}

                    {/* for supervisor */}
                    {state.user.userType == 3 && !item.isSubmitted && (
                      <>
                        <Tooltip title="Edit Daily Production" arrow>
                          <Link to={`/createDailyProduction/table/${item._id}`}>
                            <IconButton
                              size="small"
                              style={{ marginLeft: "0.5rem" }}
                            >
                              <EditIcon
                                style={{
                                  fontSize: "1.4rem",
                                  color: "#003566",
                                }}
                              />
                            </IconButton>
                          </Link>
                        </Tooltip>
                        <Tooltip title="Delete Daily Production" arrow>
                          <IconButton
                            size="small"
                            onClick={() => handleDelete(item._id)}
                            style={{ marginLeft: "0.5rem" }}
                          >
                            <DeleteIcon
                              style={{
                                fontSize: "1.4rem",
                                color: "#c80202",
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      </>
                    )}
                  </TableCell>
                  {state.user?.userType === 2 && (
                    <TableCell align="center">
                      <Button
                        variant="outlined"
                        color="white"
                        style={{
                          color: "#fafafa",
                          backgroundColor: "#161A1D",
                        }}
                        onClick={(e) => {
                          updateStatus(item._id, index);
                        }}
                        startIcon={
                          <UpdateIcon style={{ fontSize: "1.4rem" }} />
                        }
                      >
                        Update
                      </Button>
                    </TableCell>
                  )}
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        )}
      </Table>
      <DialogDelete isSubmitContent={true} />
    </section>
  );
};

export default DailyProductionTable;
